import { identity, match } from '@frontend/duck-tape';
import { useCallback, useEffect, useRef } from '@frontend/react';

export const useScrollView = (props?: {
  onRenderScroll: 'bottom' | 'center' | 'top';
  onRenderScrollDelay?: number;
}) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = useCallback(() => {
    scrollRef.current?.scrollTo({ behavior: 'smooth', top: scrollRef.current?.scrollHeight });
  }, []);

  const scrollToCenter = useCallback(
    () => scrollRef.current?.scrollTo({ behavior: 'smooth', top: scrollRef.current?.scrollHeight / 2 }),
    [],
  );

  const scrollToTop = useCallback(() => scrollRef.current?.scrollTo({ behavior: 'smooth', top: 0 }), []);
  const scrollTo = useCallback(
    (options: ScrollToOptions) => scrollRef.current?.scrollTo({ behavior: 'smooth', ...options }),
    [],
  );

  useEffect(() => {
    const scrollFn = match(props?.onRenderScroll)
      .with('bottom', () => scrollToBottom)
      .with('center', () => scrollToCenter)
      .with('top', () => scrollToTop)
      .with(undefined, () => identity)
      .exhaustive();

    setTimeout(scrollFn, props?.onRenderScrollDelay ?? 0);
  }, []);

  return { scrollRef, scrollTo, scrollToBottom, scrollToCenter, scrollToTop };
};
